import { PictureAsPdfOutlined } from '@mui/icons-material';
import { Box, Chip, IconButton, Tooltip, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HOST_API_URL } from '../../../config-global'; 

ContractTablePDFPreview.propTypes = {
    id: PropTypes.number,
    hasFile: PropTypes.bool,
    hasTerminationFile: PropTypes.bool,
};

export default function ContractTablePDFPreview({ id, hasFile, hasTerminationFile }) {

    const fileNumber = (hasFile ? 1 : 0) + (hasTerminationFile ? 1 : 0);

    const [tabValue, setTabValue] = useState(hasFile ? 'contract' : 'termination');

    useEffect(() => {
        setTabValue(hasFile ? 'contract' : 'termination');
    }, [hasFile, hasTerminationFile]);

    const onChangeTabs = (event, value) => {
        event.stopPropagation();
        setTabValue(value);
    }

    return (fileNumber ?
        <PDFButton
            number={fileNumber}
            tooltipBody={
                <>
                    <Tabs value={tabValue} onChange={(e, v) => onChangeTabs(e, v)} sx={{ minHeight: 32 }}>
                        {hasFile && <Tab label="Contract" value="contract" sx={{ minHeight: 32 }} />}
                        {hasTerminationFile && <Tab label="Termination" value="termination" sx={{ minHeight: 32 }} />}
                    </Tabs>

                    {hasFile && tabValue === 'contract' && (
                        <Box sx={{ pt: 1, height: 'calc(100% - 40px)' }}>
                            <iframe
                                style={{ width: '100%', height: '100%', border: 0 }}
                                title="Contract File"
                                src={`${HOST_API_URL}Api/Contracts/ContractFile?id=${id}&fileType=0#toolbar=0`}
                            />
                        </Box>
                    )}

                    {hasTerminationFile && tabValue === 'termination' && (
                        <Box sx={{ pt: 1, height: 'calc(100% - 40px)' }}>
                            <iframe
                                style={{ width: '100%', height: '100%', border: 0 }}
                                title="Termination File"
                                src={`${HOST_API_URL}Api/Contracts/ContractFile?id=${id}&fileType=1#toolbar=0`}
                            />
                        </Box>
                    )}
                </>
            }
        />
        : <PictureAsPdfOutlined sx={{ color: "warning.lightest" }} />
    );
}

const PDFButton = ({ number, tooltipBody }) => {
    const [open, setOpen] = useState(false);

    return (
        <Tooltip
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            disableInteractive={false}
            disableFocusListener
            leaveDelay={200}
            placement="left"
            title={tooltipBody}
            arrow
            slotProps={{
                tooltip: {
                    sx: {
                        maxWidth: 'none',
                        maxHeight: 'none',
                        height: '80vh',
                        width: '50vw',
                    },
                },
            }}
        >
            <div
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: 'rgb(241,158,59,1)',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 1,
                        transform: 'translate(-30%, -30%)',
                    }}
                >
                    {number && (
                        <Chip
                            size="small"
                            label={number || ''}
                            sx={{
                                color: 'rgb(241,158,59,1)',
                                backgroundColor: 'rgba(241, 158, 59, 0.1)',
                            }}
                        />
                    )}
                </div>
                <IconButton size="small" sx={{ p: 0.5 }} color="warning">
                    <PictureAsPdfOutlined />
                </IconButton>
            </div>
        </Tooltip>
    );
};

